/**
 * Default pack list templates shipped with the app.
 *
 * These are static data — not seeded into the database.
 * The template picker shows these alongside user-saved templates.
 */

export interface PackTemplateData {
  name: string
  description: string
  items: { name: string; description?: string; quantity?: number }[]
}

export const DEFAULT_PACK_TEMPLATES: PackTemplateData[] = [
  {
    name: '10 Essentials',
    description: 'Standard mountaineering essentials (CMC/Mountaineers)',
    items: [
      { name: 'Map & Compass', description: 'Topo map in protective case + compass' },
      {
        name: 'GPS / Communication Device',
        description: 'Phone with offline maps, PLB, or satellite communicator',
      },
      { name: 'Sunglasses', description: 'Wraparound style, critical on snow' },
      { name: 'Sunscreen & Lip Balm', description: 'SPF 30+ broad-spectrum' },
      {
        name: 'Extra Clothing / Insulation',
        description: 'Rain gear, warm layers, enough for unplanned overnight',
      },
      { name: 'Headlamp', description: 'With extra batteries' },
      { name: 'First Aid Kit', description: 'Pre-assembled kit in waterproof container' },
      {
        name: 'Fire Starter / Lighter',
        description: 'Waterproof matches + fire-starting material',
      },
      { name: 'Knife / Repair Kit', description: 'Knife, duct tape, cord, whistle' },
      { name: 'Extra Food', description: 'Calorie-dense, no-cook food for extra day' },
      { name: 'Extra Water / Treatment', description: 'Min 2L + filter or purification tablets' },
      { name: 'Emergency Shelter', description: 'Bivy sack, space blanket, or lightweight tarp' },
    ],
  },
]
